import { render, staticRenderFns } from "./DangerSignAlertDialog.vue?vue&type=template&id=4b779c56&scoped=true"
import script from "./DangerSignAlertDialog.vue?vue&type=script&lang=ts"
export * from "./DangerSignAlertDialog.vue?vue&type=script&lang=ts"
import style0 from "../styles/danger-sign-alert-dialog.css?vue&type=style&index=0&id=4b779c56&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b779c56",
  null
  
)

export default component.exports